module.exports = __webpack_public_path__ + "img/verisec.91db4167.svg";